import React from "react"
import { AggiornaDateControlloData, ApparecchioCategory, ImpiantoLight } from "../../generated";
import { GetTable } from "../../common/components/DataTable"
import { Link } from "../../common/components/link";
import { links } from "../../routes";
import DatesHelper from "../../common/datesHelper";
import { RapportoControlloModalSelector } from "../../rapporticontrollo/components/rapportoControlloModalSelector";
import ImpiantiHelper from "../ImpiantiHelper";
import OpenModalButton from "../../common/components/openModalButton";
import { AggiornaDateControlloForm } from "./aggiornaDateControlloForm";
import { safebind } from "../../common/helpers";
import { Dictionary } from "../../common/AbstractStores";
import { withApparecchioCateogories } from "../withApparecchioCategories";

const Table = GetTable<ImpiantoLight>();


const ImpiantiTable = (props: { data: ImpiantoLight[], idCliente: number, style?: React.CSSProperties, categories: Dictionary<ApparecchioCategory> }) => {

    let aggiornaDateControlloModal = React.createRef<OpenModalButton>();
    const changeCheckDate = async (impianto: ImpiantoLight, data: AggiornaDateControlloData) => {
        aggiornaDateControlloModal.current?.close();
        await ImpiantiHelper.evadiScadenze2([{ IdImpianto: impianto.id, IdCliente: impianto.idCliente }], data, props.categories);
    }

    return <Table
        data={props.data}
        keySelector={x => x.id.toString()}
        style={props.style}
        classNameSelector={x => x.dismesso ? "table-danger" : ""}
    >
        <Table.Column
            header="Descrizione"
            template={x => <Link to={links.impiantoEdit(x.id)}>
                <span className={x.dismesso ? "text-danger" : undefined}
                    style={{ textDecoration: x.dismesso ? "line-through" : undefined }}>
                    {x.marca + " " + x.modello}
                </span>
            </Link>}
            orderable={false}
            groupable={false}
        />
        <Table.Column
            header="Matricola"
            template={x => <span className={x.dismesso ? "text-danger" : undefined}
                style={{ textDecoration: x.dismesso ? "line-through" : undefined }}>
                {x.matricola}
            </span>}
            orderable={false}
            groupable={false}
        />
        <Table.Column
            header="Ult.Controllo"
            template={x => x.dataUltimoControllo ? DatesHelper.getReadableDateString(x.dataUltimoControllo) : "-"}
        />
        <Table.Column template={x => x.annoFabbricazione > 0
            ? x.annoFabbricazione.toString()
            : "N.C."} header="Anno"
        />
        <Table.Column
            groupable={false}
            orderable={false}
            template={x => <div>
                <Link to={links.impiantoEdit(x.id)} className="btn btn-sm btn-outline-secondary me-1" title="Modifica impianto">
                    <i className="fas fa-pencil-alt" title="Modifica impianto" />
                </Link>
                {!x.dismesso && <>
                    <OpenModalButton
                        ref={aggiornaDateControlloModal}
                        title="Aggiorna date controllo"
                        className="btn btn-sm btn-outline-secondary me-1"
                        modalContent={
                            <AggiornaDateControlloForm
                                impiantiIds={[x.id]}
                                onSubmit={safebind(changeCheckDate, this, x)}
                            />
                        }>
                        <i className="fas fa-calendar" />  Scadenze
                    </OpenModalButton>
                    <Link to={links.interventoNew({ idCliente: props.idCliente, idImpianto: x.id })} className="btn btn-sm btn-outline-secondary me-1" title="Aggiungi intervento">
                        <i className="fas fa-plus" /> <i className="fas fa-truck" /> Intervento
                    </Link>
                    <RapportoControlloModalSelector
                        className="btn btn-sm btn-outline-secondary me-1"
                        idImpianto={x.id}
                        idCliente={x.idCliente}
                    />
                </>}
            </div>}
        />
    </Table>

}

export default withApparecchioCateogories(ImpiantiTable)(x => x.allByKey(), "categories")